import { render, staticRenderFns } from "./ColumnButton.vue?vue&type=template&id=0488cc8e&scoped=true&"
import script from "./ColumnButton.vue?vue&type=script&lang=js&"
export * from "./ColumnButton.vue?vue&type=script&lang=js&"
import style0 from "./ColumnButton.vue?vue&type=style&index=0&id=0488cc8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0488cc8e",
  null
  
)

export default component.exports